import { useMemo } from 'react';
import { getAvatarSrc } from '../utils/getAvatarSrc';
import { useUserPreferences } from './useUserPreferences';

// this hook will return the avatar url for the user if the api call is successful
// if the api call fails, it will return an empty string
export const useAvatarUrl = () => {
  const {
    userPreferences
  } = useUserPreferences();
  const avatarUrl = useMemo(() => getAvatarSrc(userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.emailHash), [userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.emailHash]);
  return {
    avatarUrl
  };
};